<template lang="pug">
  modal(@closeModal='closeModal' :title='$t("cropImageModal.title")' maxWidth='600px')
    .container.m-top-1
      cropper.cropper(
        ref='cropper'
        :stencil-component='$options.components.RectangleStencil'
        :src='imgSrc'
        :resize-image='{adjustStencil: this.modalProps.resize || false}'
        :stencil-props='stencilProps'
        :stencilSize='stencilSize'
        :canvas="{width: this.modalProps.width, height: this.modalProps.height}"
        imageRestriction="fit-area"
        defaultBoundaries="fill"
      )
    .row.middle.space-between.m-top-2
      button.secondary-button(@click='closeModal') {{ $t('cropImageModal.cancel') }}
      button.primary-button(@click='submit') {{ $t('cropImageModal.cut') }}
</template>

<script>
import Modal from '@/components/Modal'
import { mapActions, mapState } from 'vuex'
import { Cropper, RectangleStencil } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import 'vue-advanced-cropper/dist/theme.classic.css'

export default {
  components: { Modal, Cropper, RectangleStencil },
  computed: {
    ...mapState({
      modalProps: state => state.behavior.cropImageModal.props
    }),
    imgSrc() {
      return `data:image/jpeg;base64,${this.modalProps.base64}`
    },
    stencilProps() {
      return {
        handlers: {},
        movable: true,
        resizable: this.modalProps.resize || false,
        aspectRatio: this.modalProps.width / this.modalProps.height
      }
    }
  },
  methods: {
    ...mapActions([
      'showElement',
      'hideElement'
    ]),
    stencilSize({ boundaries }) {
      return {
        width: boundaries.width,
        height: boundaries.height
      }
    },
    submit() {
      const { canvas } = this.$refs.cropper.getResult()
      if (canvas) {
        const dataUrl = canvas.toDataURL('image/png')
        this.modalProps.onSubmit(dataUrl.match(/base64(.)*/)[0].replace('base64,', ''))
        this.$refs.cropper.refresh()
        this.closeModal()
      }
    },
    closeModal() {
      this.hideElement({ element: 'cropImageModal' })
    }
  }
}
</script>

<style lang="scss" scoped>

.cropper{
  margin: 0 auto;
  width: 100%;
  height: 400px;
}
</style>
